/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Checkbox, Input, Form, Row, Typography } from 'antd';
import { ChatBotIcon } from '../../../Icons/ChatBotIcon';

// Misc imports
import userHasEditAccess from '../../../../utils/misc/hasEditAccess';
import useTheme from '../../../../utils/hooks/useTheme';

// Constant declarations
const FORM_CONFIGURATION_LAYOUT_PATH = ['settings', 'layout', 'zendesk'];

const BotDeploymentsZendeskLayoutGeneralForm = ({
  form,
  formData = {},
  isCreateMode = false,
  userRoles = {}
}) => {

  const { t } = useTranslation();
  const { formProps } = useTheme();
  const hasEditAccess = isCreateMode ? true : userHasEditAccess(formData?.tenant?.organizationId, userRoles?.organizationRoles, formData?.tenant.id, userRoles?.tenantRoles, true);

  return (
    <>
      <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
        <Col xs={formProps.mainColSpan}>
          <Typography.Text>
            {t('General Settings')}
          </Typography.Text>
          <Typography.Paragraph className="fs-sm" type="secondary">
            {t('Select a name for your agent.')}
          </Typography.Paragraph>
        </Col>

        <Col xs={formProps.secondaryColSpan}>
          <Form.Item
            label={t('Agent name')}
            name={[...FORM_CONFIGURATION_LAYOUT_PATH, 'name']}
          >
            {
              hasEditAccess
                ? <Input allowClear placeholder={t('Enter agent name')} />
                : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_LAYOUT_PATH, 'name'])}</Typography.Text>
            }
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
        <Col xs={formProps.mainColSpan}>
          <Typography.Text>
            {t('Avatars')}
          </Typography.Text>

          <Typography.Paragraph className="fs-sm" type="secondary">
            {t('Give your agent a distinct personality with special  avatars.')}
          </Typography.Paragraph>
        </Col>

        <Col xs={formProps.secondaryColSpan}>
          <Form.Item
            label={
              <Typography.Text>
                <ChatBotIcon /> {t('Agent Avatar', { context: 'AI agent' })}
              </Typography.Text>
            }
            name={[...FORM_CONFIGURATION_LAYOUT_PATH, 'avatar']}
          >
            {
              hasEditAccess
                ? <Input allowClear placeholder={t('Paste image url')}/>
                : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_LAYOUT_PATH, 'avatar'])}</Typography.Text>
            }
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
        <Col xs={formProps.mainColSpan}>
          <Typography.Text>
            {t('Actions')}
          </Typography.Text>

          <Typography.Paragraph className="fs-sm" type="secondary">
            {t(`Control your agent's behavior with custom action settings.`)}
          </Typography.Paragraph>
        </Col>

        <Col xs={formProps.secondaryColSpan}>
          <Row className="align-items-baseline">
            <Col flex="auto" xs={1}>
              <Form.Item
                labelCol={{ span: 12 }}
                name={'hideTypingIndicator'}
                valuePropName="checked"
                className="mb-2"
              >
                <Checkbox disabled={!hasEditAccess}/>
              </Form.Item>
            </Col>

            <Col>
              <Typography.Text>
                {t('Hide Typing Indicator')}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

BotDeploymentsZendeskLayoutGeneralForm.propTypes = {
  formData: PropTypes.object,
  isCreateMode: PropTypes.bool,
  userRoles: PropTypes.object,
  form: PropTypes.object
};

export default BotDeploymentsZendeskLayoutGeneralForm;
